export default {
  en: {
    installPrompt: {
      title: "Install EReMS Cameroon App",
      iosIntro: "Install this app on your iPhone:",
      iosStep1: "1. Tap the Share button",
      iosStep2: "2. Scroll and tap \"Add to Home Screen\"",
      iosStep3: "3. Tap \"Add\" in the top right",
      description: "Install our app for faster access, offline support, and a better experience!",
      worksOn: "Works on desktop and mobile",
      installNow: "Install Now",
      later: "Later",
      dismiss: "Dismiss"
    },
    cookieConsent: {
      title: "Cookie Preferences",
      description: "We use cookies to enhance your experience, analyze site traffic, and personalize content. By clicking \"Accept All\", you consent to our use of cookies. You can customize your preferences or read more in our",
      necessary: "Necessary Cookies",
      necessaryDesc: "Required for basic site functionality",
      alwaysOn: "Always On",
      analytics: "Analytics Cookies",
      analyticsDesc: "Help us improve our services",
      functional: "Functional Cookies",
      functionalDesc: "Remember your preferences",
      acceptAll: "Accept All",
      save: "Save Preferences",
      customize: "Customize",
      essentialOnly: "Essential Only",
      close: "Close cookie banner"
    },
    healthIndicator: {
      healthy: "Healthy",
      operational: "Operational",
      degraded: "Degraded",
      down: "Down"
    },
    navExtra: {
      interactiveMap: "Interactive Map",
      projectedWinners: "Projected Winners",
      electionNight: "Election Night",
      elections: "Elections",
      partyTrends: "Party Trends",
      collabLocks: "Collaboration Locks",
      userManagement: "User Management",
      planPricing: "Plan Pricing",
      badgeNew: "New",
      badgeLive: "LIVE",
      badgeAllTypes: "All Types",
      badgePro: "Pro",
      badgeAdmin: "Admin",
      badgeSuperAdmin: "Super Admin"
    }
  },
  fr: {
    installPrompt: {
      title: "Installer l'application EReMS Cameroon",
      iosIntro: "Installez cette application sur votre iPhone :",
      iosStep1: "1. Appuyez sur le bouton Partager",
      iosStep2: "2. Faites défiler et appuyez sur « Sur l'écran d'accueil »",
      iosStep3: "3. Appuyez sur « Ajouter » en haut à droite",
      description: "Installez notre application pour un accès plus rapide, un mode hors ligne et une meilleure expérience !",
      worksOn: "Fonctionne sur ordinateur et mobile",
      installNow: "Installer maintenant",
      later: "Plus tard",
      dismiss: "Fermer"
    },
    cookieConsent: {
      title: "Préférences relatives aux cookies",
      description: "Nous utilisons des cookies pour améliorer votre expérience, analyser le trafic du site et personnaliser le contenu. En cliquant sur « Tout accepter », vous consentez à l'utilisation des cookies. Vous pouvez personnaliser vos préférences ou en savoir plus dans notre",
      necessary: "Cookies nécessaires",
      necessaryDesc: "Indispensables au fonctionnement de base du site",
      alwaysOn: "Toujours activés",
      analytics: "Cookies analytiques",
      analyticsDesc: "Nous aident à améliorer nos services",
      functional: "Cookies fonctionnels",
      functionalDesc: "Mémorisent vos préférences",
      acceptAll: "Tout accepter",
      save: "Enregistrer les préférences",
      customize: "Personnaliser",
      essentialOnly: "Essentiels uniquement",
      close: "Fermer la bannière des cookies"
    },
    healthIndicator: {
      healthy: "En bonne santé",
      operational: "Opérationnel",
      degraded: "Dégradé",
      down: "Hors service"
    },
    navExtra: {
      interactiveMap: "Carte interactive",
      projectedWinners: "Vainqueurs projetés",
      electionNight: "Soirée électorale",
      elections: "Élections",
      partyTrends: "Tendances des partis",
      collabLocks: "Verrous de collaboration",
      userManagement: "Gestion des utilisateurs",
      planPricing: "Tarification des forfaits",
      badgeNew: "Nouveau",
      badgeLive: "EN DIRECT",
      badgeAllTypes: "Tous types",
      badgePro: "Pro",
      badgeAdmin: "Admin",
      badgeSuperAdmin: "Super Admin"
    }
  }
};
